import { useRouter } from 'next/router';
import { getRelatedProductsBySKU } from '@/lib/repository/machinesRepository';
import { ProductItem } from '@/lib/types/api';
import useTranslation from 'next-translate/useTranslation';
import { ProductListItem } from '@/components/section/ProductsList';
import { useQuery } from '@tanstack/react-query';

export function RelatedProducts({ product }: { product: ProductItem }) {
  const { t } = useTranslation('products');
  const { locale } = useRouter();
  const { data: relatedProducts } = useQuery(
    ['related_products', product.sku, locale],
    () => getRelatedProductsBySKU(product.sku, locale ?? 'en-US'),
    {
      enabled: !!locale && !!product.sku,
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchInterval: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnWindowFocus: false,
    }
  );

  return (
    <div className='no-print mx-2 my-16 md:mx-8'>
      <div className='pb-4 text-center'>
        <h2 className='mb-4'>
          {t('PRODUCT_RELATED_HEADER')}
          <strong>
            {product.brand.name} {product.model}
          </strong>
        </h2>
      </div>
      <div
        className='mx-auto grid max-w-7xl gap-4 md:grid-cols-2 lg:grid-cols-4'
        data-testid='related-products'
      >
        {relatedProducts &&
          relatedProducts.map((item, index) => (
            <ProductListItem key={index} p={item} />
          ))}
      </div>
    </div>
  );
}
